import { render, staticRenderFns } from "./IdentityVerificationFailure.vue?vue&type=template&id=1cae9014"
import script from "./IdentityVerificationFailure.vue?vue&type=script&lang=js"
export * from "./IdentityVerificationFailure.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports